import { attendeeFetchData, attendeeDeleteData, attendeePutData, attendeeSendData } from "./index";

const accessAPI = {
  getEventsByEmail: (data) => attendeeSendData(`/api/v2/attendees/authorize/conferences`, data),
  prepare: (data) => attendeeSendData(`/api/v2/attendees/authorize/prepare`, data),
  confirm: (data) => attendeeSendData(`/api/v2/attendees/authorize/confirm`, data),
  getEventListForAuthorizedUser: (attendeeId) => attendeeFetchData(`/api/v2/attendees/${attendeeId}/conferences`),

  authorizeUserByEmail: (data) => attendeeSendData(`/api/v2/attendees/authorize`, data),
  confirmUserByCode: (data) => attendeeSendData(`/api/v2/attendees/authorize/confirm`, data),
  fetchEventListForUser: (data) => attendeeFetchData(`/api/v2/attendees/switch/conferences`, data),
  authorizeUserByEvent: (conferenceId, data) => attendeeSendData(`/api/v2/attendees/switch/conferences/${conferenceId}`, data),
  hideEventForUser: (conferenceId) => attendeeDeleteData(`/api/v2/attendees/switch/conferences/${conferenceId}`),
};

export default accessAPI;
